export default async function downloadFile(url: string, filename: string) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch ${url}: ${response.statusText}`);
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);

  // Create an invisible link and trigger download
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename;
  link.click();

  // Cleanup
  URL.revokeObjectURL(objectUrl);

  return response;
}
